/* eslint-disable check-file/filename-naming-convention */
export const load = async ({ data }) => {
  return data;
};
